import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class GuardRule extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(GuardRule, v) : SKIP;
            },
            (v) => {
                return deserialize(GuardRule, v);
            }
        );
    }

    constructor() {
        super();

        this._item = null;
        this._amount = 0;
        this._strict = false;
        this._takeLocked = false;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get strict() {
        return this._strict;
    }

    set strict(value) {
        this._strict = value;
    }

    get takeLocked() {
        return this._takeLocked;
    }

    set takeLocked(value) {
        this._takeLocked = value;
    }

    valid() {

        if (!this.item || !this.item.valid() || this.item.any()) {
            return false;
        }

        if (this.item && !RedactorUtils.getItems().some(item => item.key?.equal(this.item))) {
            console.log('Invalid config: Missing Item for guard item');
            return false;
        }

        if (!Number.isInteger(this.amount) || this.amount < 0) {
            return false;
        }

        if (this.strict && this.amount < 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.item || this.item.empty();
    }

    copy() {
      return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GuardRule());
        } else if (target instanceof GuardRule) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(GuardRule, {
    _item: alias("item", ItemKey.schema()),
    _amount: alias("amount", Schema.primitive()),
    _strict: alias("strict", Schema.primitive()),
    _takeLocked: alias("take_locked", Schema.primitive()),
});